import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=888b07ee&scoped=true&"
import script from "./Room.vue?vue&type=script&lang=ts&"
export * from "./Room.vue?vue&type=script&lang=ts&"
import style0 from "./Room.vue?vue&type=style&index=0&id=888b07ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b07ee",
  null
  
)

export default component.exports